import { RootState } from '@core/Store'

export function getFeatures(state: RootState) {
  return state.features.features
}

export function getFeatureState(state: RootState) {
  return state.features
}

export function getFeaturesIsUserAnonymous(state: RootState) {
  return state.features.isUserAnonymous
}

export function getFeatureStateInitializedFlag(state: RootState) {
  return state.features.isLdInitialized
}
